var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#6BC7A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9l3 3 6-6.5",
    stroke: "#2DBA6E",
    strokeWidth: 1.5
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBvcGFjaXR5PSIwLjEiIGN4PSI5IiBjeT0iOSIgcj0iOSIgZmlsbD0iIzZCQzdBMSIvPgo8cGF0aCBkPSJNNSA5TDggMTJMMTQgNS41IiBzdHJva2U9IiMyREJBNkUiIHN0cm9rZS13aWR0aD0iMS41Ii8+Cjwvc3ZnPgo=";
export { SvgStatusSuccess as ReactComponent };